import React from 'react'
import {compose, lifecycle, withHandlers, withState} from "recompose";
import getImgUrl from '../getImgUrl'
import getUrl from '../getUrl'
import _ from 'lodash'
import styled from 'styled-components'
import * as media from '../media'
import {browserHistory} from 'react-router'
import TextEditor from '../text/new'

const Header = styled.div`
  margin: 40px;
  margin-left:0;
  margin-right:0;
  font-size: 24px;
  font-weight: 800;
  ${media.smallerThan(700)`text-align: center;`}
`

const DateContainer = styled.div`
  ${media.smallerThan(700)`text-align: center;`}
`

const ImageContainer = styled.div`
  height: auto;
  width: 400px;
  height: 300px;
  border: 1px solid rgb(225, 225, 225);
  padding: 10px;
  margin-right: 15px;
  margin-bottom: 15px;
  float: left;
  display: flex;
  justify-content: center;
  align-items: center;

  &:after {
    content: "";
    display: table;
    clear: both;
  }

  ${media.smallerThan(700)`
  width: 100%;
  float: initial;
  `}
`

const FullContent = styled.div`
  vertical-align: top;
  display: inline-block;
  word-break: break-word;
  display: inline;

  ${media.smallerThan(700)`display: block; text-align: center; `}
  
  & img {
    max-width: 80vw;
    height: auto;
  }
`

const Container = styled.div`
  margin-top: 15px;
  &:after {
    content: "";
    display: table;
    clear: both;
  }
`

const ButtonLeft = styled.div`
  color: white; 
  padding: 15px; 
  background: rgb(23, 61, 176);
  cursor: pointer;
  width: 250px;

  ${media.smallerThan(700)`
  width: 35vw;
  margin-right: auto; `}
`

const ButtonRight = styled.div`
  color: white; 
  padding: 15px; 
  background: rgb(23, 61, 176);
  cursor: pointer;
  width: 250px;
  margin-left: 40px;

  ${media.smallerThan(700)`
  width: 35vw;
  margin-left: auto; `}
`

class OneNew extends React.Component {
  render() {
    const {data} = this.props
    const date = new Date(data.start_date);
    return (
      <div>

        <div style={{width: '80%', margin: '0px auto'}}>
          <Header>
            {data.name}
          </Header>
          <DateContainer>
            {`${date.getDate()}.${(date.getMonth() < 9 ? '0' : '') + (date.getMonth() + 1)}.${date.getFullYear()}`}
          </DateContainer>

          <Container>
            <ImageContainer>
              <img
                src={getImgUrl('/media/static/press/' + _.get(data, 'image_url'))}
                style={{
                  maxWidth: '100%',
                  maxHeight: '100%',
                  margin: 'auto',
                }}
              />
            </ImageContainer>


            <FullContent>
              <TextEditor id={this.props.params.id}/>
            </FullContent>

          </Container>

          <div style={{marginTop: 20, textAlign: 'center', display: 'flex', justifyContent: 'center'}}>
            <ButtonLeft
              style={{
                ...(!_.get(data, 'previous_id') && {background: 'white', cursor: 'default'})
              }}
              onClick={() => {
                _.get(data, 'previous_id') &&
                browserHistory.push("/new/" + _.get(data, 'previous_id'))
              }}
            >
              {` ${_.get(data, 'previous_name')}`}
            </ButtonLeft>

            <ButtonRight
              style={{
                ...(!_.get(data, 'next_id') && {background: 'white', cursor: 'default'})
              }}
              onClick={() => {
                _.get(data, 'next_id') &&
                browserHistory.push("/new/" + _.get(data, 'next_id'))
              }}
            >
              {`${_.get(data, 'next_name')} `}
            </ButtonRight>
          </div>

        </div>

      </div>

    )
  }
}

const enhance = compose(
  withState('loading', 'setLoading', false),
  withState('data', 'setData', 0),

  withHandlers({
    fetchDict: props => ({...rest}) => {
      props.setLoading(true)
      fetch(getUrl(`/api/v1/dictionaries/fw/press/${props.params.id}`))
        .then(data => {
          return data.json()
        }).then(response => {
        props.setLoading(false)
        props.setData(_.get(response, 'data.data[0]'))
      }).catch(err => {
        console.log(err)
        props.setLoading(false)
      })
    },
  }),

  lifecycle({
    componentDidMount() {
      this.props.fetchDict(this.props)
    },
    componentDidUpdate(prevProps) {
      if (this.props.params.id != prevProps.params.id) {
        this.props.fetchDict(this.props)
      }
    }
  }),
)

export default enhance(OneNew)



// WEBPACK FOOTER //
// ./src/pages/new.js